<template>
  <el-popover
    v-bind="$attrs"
    :popper-class="computedPopperClass"
    :content="content"
    v-on="$listeners"
  >
    <div class="popover-image">
      <slot>
        <div v-if="contentSlotDefault">
          <div
            v-for="(item, index) in contentSlotDefault"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </slot>
    </div>
    <slot
      slot="reference"
      name="reference"
    />
  </el-popover>
</template>

<script>
export default {
  name: 'RtPopover',
  props: {
    popperClass: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    // 换行模式
    wordBreak: {
      type: String,
      default: 'break-all'
    }
  },
  data () {
    return {
      defaultPopperClass: 'rt-xpc-box-shadow-base '
    };
  },
  computed: {
    computedPopperClass () {
      let classList = this.defaultPopperClass + this.popperClass;
      classList += ` rt-xpc-popover-${this.wordBreak}`;

      return classList;
    },
    contentSlotDefault () {
      return this.content && this.content.includes('\n')
        ? this.content.split('\n')
        : null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtPopover.vue?1860af3a